export default { sha: '04d2d02430809fad428e4ce4d5ed72a9024769e9', buildNumber: 'undefined' }
